import { Controller } from "stimulus";
import debounce from "lodash.debounce";
import { ProductCard } from "../components";
import { productCardAnchorHandler } from "../helpers";

export default class extends Controller {
  static targets = [
    "search",
    "basketCount",
    "searchProductResults",
    "searchCollectionResults",
    "header",
  ];

  connect() {
    this.handlePredictiveSearch = debounce(this.handlePredictiveSearch, 300);
    if (
      this.hasSearchCollectionResultsTarget &&
      this.hasSearchProductResultsTarget
    ) {
      this.initialCollections = this.searchCollectionResultsTarget.innerHTML;
      this.initialProducts = this.searchProductResultsTarget.innerHTML;
    }

    const searchToggle = document.querySelector(".search-icons");
    if (searchToggle) {
      searchToggle.addEventListener("keydown", function (e) {
        if (e.key === " " || e.key === "Enter") {
          e.preventDefault();
          const searchTrigger = document.getElementById(e.target.htmlFor);
          searchTrigger.checked = !searchTrigger.checked;
        }
      });
    }

    let hasSmile = false;

    function handleSmileWidget() {
      const smileContainer = document.querySelector(
        "[id^='smile-ui'][id$='container']"
      );
      if (!smileContainer && hasSmile === false) {
        setTimeout(handleSmileWidget, 500);
      } else {
        hasSmile = true;
        smileContainer.style.zIndex = 10;
      }
    }

    handleSmileWidget();
  }

  expandTruncate(e) {
    e.preventDefault();
    const target = document.querySelector(".collection-hero__body--truncated");
    target.classList.add("hidden");
    target.nextElementSibling.style = "display: block;";
  }

  async handlePredictiveSearch(e) {
    if (e.target.value.length <= 0) {
      this.searchCollectionResultsTarget.innerHTML = this.initialCollections;
      this.searchProductResultsTarget.innerHTML = this.initialProducts;

      return;
    }

    try {
      this.searchProductResultsTarget.innerHTML = "<div class='loader'></div>";
      const res = await fetch(
        `${window.location.origin}/search/suggest.json?q=${e.target.value}&resources[type]=product,collection`
      );

      if (res.ok) {
        const data = await res.json();
        const results = data?.resources?.results;

        if (results && results.products.length > 0) {
          const limit = results.length < 3 ? results.length : 3;
          let count = 0;

          let cards = [];
          for await (const product of results.products) {
            if (product.type !== "Subscription" && count < 3) {
              count++;
              cards.push(
                await ProductCard({
                  product,
                  variant: product.variants[0]?.id,
                  scope: "search",
                })
              );
            }
          }

          this.searchProductResultsTarget.innerHTML = cards.join("");
          this.searchProductResultsTarget
            .querySelectorAll("article")
            .forEach((article) => {
              productCardAnchorHandler(article);
            });
        } else {
          this.searchProductResultsTarget.innerHTML =
            "<p class='tw-uppercase' style='font-size: 1.6rem; letter-spacing: 0.2rem;'>No Products Found</p>";
        }

        if (results && results.collections.length > 0) {
          const collections = `
          <dt data-ui-target="searchCollectionResults"><h2>Suggestions</h2></dt>
          ${results.collections
            .map(
              (collection) =>
                `<dd><a href="${collection.url}">${collection.title}</a></dd>`
            )
            .join("")}`;

          this.searchCollectionResultsTarget.innerHTML = collections;
        }
      } else {
        console.error("There was an error", res);
      }
    } catch (error) {
      console.error("There was an error", error);
    }
  }

  toggleOverflow() {
    document.body.classList.toggle("no-scroll");
    document.documentElement.classList.toggle("no-scroll");
  }

  handleLinkClick(e) {
    e.preventDefault();

    const manualURL = e.currentTarget.dataset.href.replace("#", "");
    const target = document.querySelector(`[id^="${manualURL}"]`);

    if (target) {
      return (window.location.href = `${window.location.pathname}#${target.id}`);
    }

    return (window.location.href = e.currentTarget.href);
  }

  handleMenu() {
    this.headerTarget
      .querySelectorAll(".mobile-nav__submenu-toggle")
      .forEach((checkbox) => (checkbox.checked = false));
  }
}
